import { BseDto, NegotiationRoundDto, SeDto } from "../../autogen/bff-api";

export const eventIsCompleted = ({ event, round }: { event: BseDto | SeDto; round?: NegotiationRoundDto }): boolean => {
  if (event.status === "Awarded") return true;
  if (round) return round.stateName === "Completed";
  return event.status === "Completed";
};
